import React from 'react';
import { SCENARIOS } from '../../lib/scenarios';
import { ScenarioCard } from '../shared/ScenarioCard';

// Three scenario cards in the ExplorerView left panel. Each card is a
// single-click entry point — clicking navigates to DetailView with the
// target mill + scenario id in router state so DetailView picks it up on
// mount. Persistent (always visible) so users can move fluidly between
// free exploration and guided scenarios.

interface ScenarioSelectorProps {
  // When true, the selector adds a brief visual pulse on mount. Used by the
  // ?mode=scenario URL nudge to draw the eye without a forced modal.
  highlightOnMount?: boolean;
}

export const ScenarioSelector: React.FC<ScenarioSelectorProps> = ({
  highlightOnMount = false,
}) => {
  return (
    <section
      data-scenario-selector
      className={`space-y-3 ${highlightOnMount ? 'scenario-pulse' : ''}`}
    >
      <div className="flex items-baseline justify-between">
        <h3 className="text-body font-roboto font-bold text-figma-text">
          Start with a scenario
        </h3>
        <span className="text-xs font-roboto-mono text-figma-yellow/80 uppercase tracking-wider">
          Guided
        </span>
      </div>
      <div className="space-y-2">
        {SCENARIOS.map((scenario) => (
          <ScenarioCard key={scenario.id} scenario={scenario} />
        ))}
      </div>
    </section>
  );
};
